import React, { createRef, useEffect } from "react";
import { BASE_URL } from "../../../../constant/constant";
import { usePositionedScreenContext } from "../../PositionedScreen";

const ColumnNode = ({ node, className, style, renderLayout, resizeHandle, handlers }) => {
  const { elementRefs } = usePositionedScreenContext();

  if (elementRefs?.current && node?.id) {
    if (!elementRefs.current[node.id]) {
      elementRefs.current[node.id] = createRef();
    }
  }

  const background = node?.config?.repo_source
    ? {
        backgroundImage: `url(${BASE_URL}/api/v1/public/${node?.config?.repo_source})`,
        backgroundSize: "cover"
      }
    : {};

  useEffect(() => {
    const el = elementRefs.current[node.id]?.current;
    if (el) {
      el.setAttribute("data-type", node.type);
    }
  }, [elementRefs, node.id, node.type]);

  return (
    <div
      key={node.id}
      ref={elementRefs.current[node.id]}
      title={node.type}
      className={`z-column ${className}`}
      style={{ ...style, ...background }}
      {...handlers}
    >
      {resizeHandle(node)}
      {renderLayout(node.children)}
    </div>
  );
};

export default ColumnNode;
